import AMapLoader from '@amap/amap-jsapi-loader';
import { useEffect, useRef } from 'react';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';

const LNG_LAT = [113.8295, 22.6705];

export default function ContactMap() {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const { t } = useLanguage();

  useEffect(() => {
    const key = process.env.REACT_APP_AMAP_KEY;
    if (!key || key === 'your_amap_key_here') return;

    const companyName = t.contact.mapCompanyName;
    const address = t.contact.mapAddress;
    const addressLabel = t.contact.mapAddressLabel;

    AMapLoader.load({ key, version: '2.0' })
      .then((AMap) => {
        const isMobile = window.innerWidth <= 768;
        const map = new AMap.Map(containerRef.current, {
          zoom: isMobile ? 17 : 16,
          center: LNG_LAT,
          mapStyle: 'amap://styles/light',
        });
        mapRef.current = map;

        const blueDot = `<div style="
          width:16px;height:16px;background:#4a90d9;border-radius:50%;
          border:3px solid #fff;box-shadow:0 2px 10px rgba(74,144,217,0.6);
        "></div>`;

        const marker = new AMap.Marker({
          position: LNG_LAT,
          content: blueDot,
          offset: new AMap.Pixel(-8, -8),
        });

        const infoContent = isMobile
          ? `<div style="padding:8px 12px;width:260px;line-height:1.6">
              <b style="color:#2c3e50;font-size:13px">${companyName}</b>
              <p style="margin:4px 0 0;color:#6b7280;font-size:12px">${addressLabel}：${address}</p>
            </div>`
          : `<div style="padding:10px 14px;width:360px;line-height:1.8">
              <b style="color:#2c3e50;font-size:14px">${companyName}</b>
              <p style="margin:6px 0 0;color:#6b7280;font-size:13px">${addressLabel}：${address}</p>
            </div>`;

        const infoWindow = new AMap.InfoWindow({
          content: infoContent,
          offset: new AMap.Pixel(0, -20),
        });

        marker.on('click', () => infoWindow.open(map, marker.getPosition()));
        map.add(marker);
        infoWindow.open(map, LNG_LAT);

        if (isMobile) {
          // map.on('complete', () => map.panBy(0, -80));
        }
      })
      .catch(console.error);

    return () => {
      mapRef.current?.destroy();
    };
  }, [t]);

  const keyMissing =
    !process.env.REACT_APP_AMAP_KEY ||
    process.env.REACT_APP_AMAP_KEY === 'your_amap_key_here';

  if (keyMissing) {
    return (
      <div
        className="contact-map-container"
        style={{
          background: '#f0f4ff',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#6b7280',
          gap: 12,
        }}
      >
        <span style={{ fontSize: '3rem' }}>🗺️</span>
        <p>
          请在 <code>.env</code> 文件中配置 <code>REACT_APP_AMAP_KEY</code>
        </p>
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className="contact-map-container"
    />
  );
}
